import { Box, Stack, Text } from '@chakra-ui/react';
import { TextLink } from '@time-line/components/common';
import { NewsletterSignup as BaseNewsletterSignup } from 'components/common/NewsletterSignup';
import { useSiteSpecificRoutes } from 'hooks/useSiteSpecificRoutes';

type NewsletterSignupProps = {
  headingLabel?: string;
  hideHeadingOnDesktop?: boolean;
};

export function NewsletterSignup({
  headingLabel = 'Newsletter',
  hideHeadingOnDesktop = true,
}: NewsletterSignupProps) {
  const [PRIVACY_POLICY] = useSiteSpecificRoutes(['PRIVACY_POLICY']);

  return (
    <Stack gap={0} mt={{ base: '2xs', lg: 0 }}>
      <Text
        as="h3"
        size="overline"
        mb="2xs"
        display={{ base: 'block', lg: hideHeadingOnDesktop ? 'none' : 'block' }}
      >
        {headingLabel}
      </Text>
      <Box pt="3xs">
        <BaseNewsletterSignup source="footer" />
      </Box>
      <Text size="detail" color="blackAlpha.700" mt="4xs">
        By signing up, you agree to our{' '}
        <TextLink
          href={PRIVACY_POLICY}
          textProps={{ size: 'detail', color: 'blackAlpha.700' }}
          variant="underlineOnHover"
        >
          privacy policy
        </TextLink>
      </Text>
    </Stack>
  );
}
